import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import logo from '../../assets/logo.png';
import './Sidebar.css';
// menu icons
import usersIcon from '../../assets/menu/menu_user.png';
import userIconSelected from '../../assets/menu/menu_user_selected.png';
import groupsIcon from '../../assets/menu/menu_group.png';
import groupIconSelected from '../../assets/menu/menu_group_selected.png';
import customersIcon from '../../assets/menu/menu_customer.png';
import customerIconSelected from '../../assets/menu/menu_customer_selected.png';
import rolesIcon from '../../assets/menu/menu_roles.png';
import roleIconSelected from '../../assets/menu/menu_roles_selected.png';
import tokensIcon from '../../assets/menu/menu_token.png';
import tokenIconSelected from '../../assets/menu/menu_token_selected.png';
import supportIcon from '../../assets/menu/menu_support.png';
import supportIconSelected from '../../assets/menu/menu_support_selected.png';
import helpIcon from '../../assets/menu/menu_help.png';
import helpIconSelected from '../../assets/menu/menu_help_selected.png';
import dashboardIcon from '../../assets/menu/menu_dashboard.png';
import dashboardIconSelected from '../../assets/menu/menu_dashboard_selected.png';
import configurationsIconSelected from '../../assets/menu/menu_configurations_selected.png';
import logoutIcon from '../../assets/menu/menu_logOut.png';
import { logout } from '../../store/slices/authSlice';
// utils
import { permissionsService } from '../../utils/permissionsService';
import { tokenService } from '../../services/auth/tokenService';
//services
import { authService } from '../../services/login';

const menuItems = [
  { 
    path: '/dashboard', 
    icon: dashboardIcon, 
    selectedIcon: dashboardIconSelected, 
    label: 'Dashboard',
    permissions: ''
  },
  { 
    path: '/users', 
    icon: usersIcon, 
    selectedIcon: userIconSelected, 
    label: 'User management',
    permissions: 'user_management'
  },
  { 
    path: '/groups', 
    icon: groupsIcon, 
    selectedIcon: groupIconSelected, 
    label: 'Group management',
    permissions: 'group_management'
  },
  { 
    path: '/customers', 
    icon: customersIcon, 
    selectedIcon: customerIconSelected, 
    label: 'Customer management',
    permissions: 'client_management'
  },
  { 
    path: '/dashboard/roles', 
    icon: rolesIcon, 
    selectedIcon: roleIconSelected, 
    label: 'Roles',
    permissions: 'roles_permissions_management'
  },
  { 
    path: '/dashboard/tokens', 
    icon: tokensIcon, 
    selectedIcon: tokenIconSelected, 
    label: 'Barter Bucks management',
    permissions: 'token_management'
  },
  { 
    path: '/support', 
    icon: supportIcon, 
    selectedIcon: supportIconSelected, 
    label: 'Support',
    permissions: 'support_management'
  },
  {
    path: '/configurations', 
    icon: supportIcon, 
    selectedIcon: configurationsIconSelected, 
    label: 'Configurations',
    permissions: ''
  }
];

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
    authService.logout();
    permissionsService.clearPermissions();
    tokenService.clearTokens();
    navigate('/');
  };

  const hasPermission = (permission) => {
    if (!permission) return true;
    
    const permissions = permissionsService.getPermissions();
    if (!permissions || !Array.isArray(permissions)) return false;
    
    const module = permissions.find(module => module.name === permission);
    if (!module) return false;

    if(permission === 'client_management' || permission === 'support_management') {
      return module.permissions && Array.isArray(module.permissions) && 
             module.permissions.some(permission => permission.name === 'view');
    }
    
    return true;
  };
  
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <img src={logo} alt="Barterflip Logo" className="sidebar-logo" />
      </div>
      
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          hasPermission(item.permissions) && (
            <NavLink
              key={item.path}
              to={item.path}
            >
              {({ isActive: linkActive }) => {
              // Para Dashboard, solo activo si estamos exactamente en /dashboard
              // Para otros items, activo si la ruta coincide Y no estamos en /dashboard
              const isActive = item.path === '/dashboard' 
                ? location.pathname === '/dashboard'
                : linkActive && location.pathname !== '/dashboard';

              return (
                <div className={`nav-item ${isActive ? 'active' : ''}`}>
                  <img 
                    src={isActive ? item.selectedIcon : item.icon} 
                    alt={item.label} 
                    className="nav-icon" 
                  />
                  <span className="nav-label">{item.label}</span>
                </div>
              );
            }}
          </NavLink>
          )
        ))}
      </nav>

      <div className="sidebar-footer">
        <div 
          className="nav-item" 
          onClick={handleLogout}
          role="button"
          tabIndex={0}
          style={{ cursor: 'pointer' }}
        >
          <img 
            src={logoutIcon} 
            alt="Logout" 
            className="nav-icon" 
          />
          <span className="nav-label-logout">Logout</span>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
